module.exports = __webpack_public_path__ + "static/img/zephyr-logo.2dfef4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zephyr-logo.png
// module id = A94v
// module chunks = 0